import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import Section from '../../components/layout/Section';
import ContentPlain from '../../components/layout/ContentPlain';
import ProductActions from '../../store/productRedux'
import './OTECaseInfoPage.scss'
import CaseBasicInformation from './components/CaseBasicInformation';
import PaymentInfo from '../../components/paymentInformation/PaymentInfo';

const OTECaseInfoPage = () => {
    const dispatch = useDispatch();

    const { id } = useParams();

    const [payments, setPayments] = useState([])

    const oteCase = useSelector(x => x.product.selectedOte, shallowEqual);
    const lang = useSelector(x => x.layout.lang);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (id) {
            // reset selected ticket to null
            dispatch(ProductActions.setSelectedOte(null));
            dispatch(ProductActions.getSelectedOte(id))
        }
    }, [id]);

    useEffect(() => {
        return () => dispatch(ProductActions.setSelectedOte(null));
    }, [])

    useEffect(() => {
        if (oteCase) {
            setPayments(oteCase.return_details.paymentDetails)
        } else {
            setPayments([])
        }
    }, [oteCase])

    return (
        <div className="content-grid tickets">
            <Section sectionId='section-ote-head' className='white'>
                <ContentPlain elementId='ote-header'>
                    <CaseBasicInformation oteCase={oteCase}/>
                </ContentPlain>
            </Section> 
            <Section sectionId='section-ote-body' className='light-functional-grey'>
                <ContentPlain elementId='ote-payments'>
                    <div className='columns'>
                        <div className='column is-12'>
                            <PaymentInfo payments={payments} lang={lang} />
                        </div>
                    </div>
                </ContentPlain>
            </Section>
        </div>
    );
}

export default OTECaseInfoPage